import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, InsertLinkOutlined } from "@mui/icons-material";
import { Box, Chip } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { useAppSelector } from "../../../store/hooks";
import { faintblue } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate } from "../../../utils/utils";
import { getstockTransferRequisition, priorityListGet, stockTransferRequisitionAttachmentDelete, stockTransferRequisitionCreate, uploadStockTransferRequisitionAttachment, warehouseListGet } from "../apiCall";
import StockAdjustmentRequistionPartDetails from "../components/stockRequistionPartDetails";
import { StockTransferRequisitionAPIKeys } from "../entity";
export var CreateStockTransferRequisition = function () {
    var _crud$StockTransferRe, _getLocalStorageItem, _getLocalStorageItem2, _data$Status, _crud$profilePersonal, _crud$profilePersonal2, _crud$profilePersonal3, _crud$profilePersonal4;
    var navigate = useNavigate();
    var _a = useState(false), priority = _a[0], setPriority = _a[1];
    var crud = useAppSelector(function (state) { return state.crud; });
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var dispatch = useDispatch();
    var id = useParams().id;
    var data = (_crud$StockTransferRe = crud[StockTransferRequisitionAPIKeys.get]) === null || _crud$StockTransferRe === void 0 ? void 0 : _crud$StockTransferRe.data;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var isDisable = (data === null || data === void 0 || (_data$Status = data.Status) === null || _data$Status === void 0 ? void 0 : _data$Status.Key) === 'Completed' ? true : false;
    var warehouseList = function (params) { return warehouseListGet(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            TenantId: UserOrganization
        })
    })); };
    var step1 = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic Details',
            elements: [{
                    type: FormItemTypes.DatePicker,
                    name: 'ExpectedTransferDate',
                    label: 'Expected transfer date',
                    required: true,
                    disabled: isDisable
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SourceWarehouseId',
                    label: 'Warehouse',
                    getListData: warehouseList,
                    required: true,
                    valueExpr: "id",
                    displayExpr: "Name",
                    disabled: isDisable,
                    setFormState: function (value, currValue) {
                        return {
                            DestinationWarehouseId: currValue === null || currValue === void 0 ? void 0 : currValue.id
                        };
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PriorityId',
                    label: 'Priority',
                    required: true,
                    disabled: isDisable,
                    getListData: priorityListGet,
                    onChange: function (e, value) {
                        setPriority(value.Name === 'High');
                    }
                }, priority ? {
                    type: FormItemTypes.TextInput,
                    name: 'PriorityRemarks',
                    label: 'Priority reason',
                    disabled: isDisable,
                    multiline: true,
                    minRows: 2,
                    required: true,
                    placeholder: 'Enter priority reason'
                } : null]
        }, {
            type: FormItemTypes.Custom,
            name: "StockTransferRequisitionDetail",
            element: StockAdjustmentRequistionPartDetails,
            columnSize: 12,
            disabled: isDisable
        }];
    var step2 = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Notes & attachments',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'Notes & attachments',
                    label: 'Notes & attachments',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'Remarks',
                            label: 'Transfer reasons (0/200 characters)',
                            placeholder: 'Enter reasons',
                            multiline: true,
                            md: 6,
                            minRows: 2,
                            disabled: isDisable
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'Attachments',
                            label: 'Add attachments',
                            value: null,
                            placeholder: 'Upload Files',
                            disabled: isDisable,
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            },
                            uploadAttachmentRequest: {
                                systemname: StockTransferRequisitionAPIKeys.AttachmentSystemName
                            },
                            uploadAttachmentAPI: uploadStockTransferRequisitionAttachment,
                            deleteAttachmentAPI: stockTransferRequisitionAttachmentDelete
                        }]
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General & part detail',
            elements: step1
        }, {
            id: '1',
            label: 'Additional information',
            elements: step2
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'pageHeader',
            columnSize: 12,
            justifyContent: 'space-between',
            alignItems: 'center',
            spacing: 0,
            columnSpacing: 1,
            gap: 2,
            p: 2,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    spacing: 0,
                    xs: 12,
                    sm: 0,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            columnSize: 0,
                            onClick: function () { return navigate('/stockTransferRequisition'); },
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            children: mode == 'edit' ? 'Edit stock transfer requisition' : 'Create stock transfer requisition',
                            columnSize: 0,
                            variant: "h1",
                            noWrap: true
                        }, mode !== "add" ? {
                            type: FormItemTypes.Custom,
                            name: '',
                            columnSize: 0,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'none',
                                        md: 'flex'
                                    }
                                }
                            },
                            element: function (props) {
                                var _props$value;
                                return /*#__PURE__*/ React.createElement(Chip, {
                                    label: props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 || (_props$value = _props$value.Status) === null || _props$value === void 0 ? void 0 : _props$value.Name,
                                    size: "small",
                                    variant: "outlined",
                                    sx: {
                                        borderRadius: 2,
                                        px: 1,
                                        fontWeight: 'bold'
                                    },
                                    icon: /*#__PURE__*/ React.createElement(Box, {
                                        height: 8,
                                        width: 8,
                                        borderRadius: 10,
                                        bgcolor: "gray"
                                    })
                                });
                            }
                        } : null]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    xs: 12,
                    sm: true,
                    item: false,
                    justifyContent: {
                        xs: 'space-between',
                        sm: 'flex-end'
                    },
                    spacing: 0,
                    p: {
                        xs: 2,
                        sm: 0
                    },
                    alignItems: 'center',
                    elements: mode !== "edit" ? [] : [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentCode',
                            label: 'DOC NUMBER: ',
                            columnSize: 0,
                            fontWeight: 400,
                            fontSize: 12,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedOn',
                            label: 'DOC DATE: ',
                            valueGetter: function (formData) {
                                return dateFormate(formData === null || formData === void 0 ? void 0 : formData.CreatedOn);
                            },
                            columnSize: 0,
                            fontWeight: 400,
                            fontSize: 12,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Quick Links',
                            disabled: true,
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            height: '100%',
                            width: '2px',
                            bgcolor: 'rgba(0,0,0,0.1)',
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            disabled: isDisable,
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            label: "",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            variant: 'scrollable',
            columnSize: 12,
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Save',
                    columnSize: 0,
                    variant: 'contained',
                    disabled: isDisable,
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    var handleOnFormClose = function () {
        if (mode == "add") {
            dispatch(showNotification({
                isOpen: true,
                message: "Stock Transfer Requisition Created Successfully",
                type: "success"
            }));
        }
        else {
            dispatch(showNotification({
                isOpen: true,
                message: "Stock Transfer Requisition Updated Successfully",
                type: "success"
            }));
        }
        navigate("/stockTransferRequisition");
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 2,
        formProps: {
            bgcolor: faintblue
        },
        getFormAPI: getstockTransferRequisition,
        getKey: StockTransferRequisitionAPIKeys.get,
        getRequest: {
            id: id
        },
        pagingAPIKey: StockTransferRequisitionAPIKeys.paging,
        createKey: StockTransferRequisitionAPIKeys.create,
        createFormAPI: stockTransferRequisitionCreate,
        createRequest: {
            AssignTo: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.IdentityId,
            SourceTenantId: UserOrganization,
            SourceParentTenantId: UserParentOrganization,
            DestinationTenantId: UserOrganization,
            DestinationParentTenantId: UserParentOrganization,
            TotalQuantity: 0,
            TotalAmount: 0,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal2 = crud.profilePersonalDetails) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.data) === null || _crud$profilePersonal2 === void 0 ? void 0 : _crud$profilePersonal2.IdentityId,
            DocumentDate: new Date().toISOString(),
            RejectRemarks: "NA",
            Type: "Requisition",
            Status: "Draft"
        },
        updateRequest: {
            Remarks: "",
            AssignTo: crud === null || crud === void 0 || (_crud$profilePersonal3 = crud.profilePersonalDetails) === null || _crud$profilePersonal3 === void 0 || (_crud$profilePersonal3 = _crud$profilePersonal3.data) === null || _crud$profilePersonal3 === void 0 ? void 0 : _crud$profilePersonal3.IdentityId,
            SourceTenantId: UserOrganization,
            SourceParentTenantId: UserParentOrganization,
            DestinationTenantId: UserOrganization,
            DestinationParentTenantId: UserParentOrganization,
            TotalQuantity: 0,
            TotalAmount: 0,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal4 = crud.profilePersonalDetails) === null || _crud$profilePersonal4 === void 0 || (_crud$profilePersonal4 = _crud$profilePersonal4.data) === null || _crud$profilePersonal4 === void 0 ? void 0 : _crud$profilePersonal4.IdentityId,
            RejectRemarks: "NA",
            Type: "Requisition",
            Status: "Draft"
        },
        updateFormAPI: stockTransferRequisitionCreate,
        updateKey: StockTransferRequisitionAPIKeys.update,
        onClose: handleOnFormClose
    }));
};
